import { type BaseSelectProps, MenuItem, Select, Stack } from '@mui/material';
import { useField } from 'formik';
import { useId } from 'react';

import { FormField } from 'common';

import { AgentCategory, AgentCategoryIcon } from '../../common/Icons/Icons';

interface AgentCategorySelectProps extends Partial<BaseSelectProps<AgentCategory>> {
  fieldName: string;
  label: string;
  helperText?: string;
  disabled?: boolean;
}

export function AgentCategorySelect(props: AgentCategorySelectProps) {
  const { fieldName, label, helperText, ...fieldProps } = props;
  const [field, { touched, error }] = useField<AgentCategory>(fieldName);

  const showError = touched && !!error;
  const fieldId = useId();
  return (
    <FormField
      id={fieldId}
      label={label}
      helperText={helperText}
      error={showError ? error : undefined}
    >
      <Select
        id={fieldId}
        {...fieldProps}
        {...field}
        value={field.value ?? AgentCategory.Placeholder}
        aria-label={label}
        disabled={props.disabled}
        error={showError}
      >
        {Object.values(AgentCategory)
          .sort()
          .map((category) => {
            return (
              <MenuItem key={category} value={category}>
                <Stack direction="row" alignItems="center" gap={1}>
                  <AgentCategoryIcon category={category} />{' '}
                  {category.replace(/([A-Z])/g, ' $1').trim()}
                </Stack>
              </MenuItem>
            );
          })}
      </Select>
    </FormField>
  );
}
